import React, {useState} from "react";
import TrackOrderForm from "./forms/TrackOrderForm";
import QuickBooking from "./forms/QuickBooking";
import LocationsOurBranches from "./forms/LocationsOurBranches";
import Tabs from "./Tabs";
import {LogoAsBg, ServicesIcon} from "../../assets/icons";
import {useLanguage} from "../../hooks/LanguageContext";
import ShippingPrices from "./forms/ShippingPrices";

const TrackYourOrder = () => {
	const [tab, setTab] = useState(1);
	const { direction } = useLanguage(); // Get current language direction (rtl or ltr)

	const handleTab = (tab) => {
		setTab(tab);
	};

	return (
		<section
			className={`relative z-[99] md:-top-[300px]  ${
				direction === "rtl"
					? "-left-1/2 translate-x-1/2"
					: "-right-1/2 -translate-x-1/2"
			} w-full 2xl:max-w-[80%] border-[7px] border-primary-700 md:rounded-[20px] rounded-lg bg-bg-light flex flex-col items-start md:py-[100px] py-8 md:px-[50px] px-8`}
		>
			<LogoAsBg
				className={`hidden md:block md:opacity-70 lg:opacity-100 absolute -bottom-[14rem] z-[9999] overflow-hidden ${
					direction === "rtl" ? "2xl:-right-72 -right-28" : "scale-x-[-1]  2xl:-left-72 -left-28 "
				}`}
			/>
			<ServicesIcon
				className={`absolute bottom-[-8rem] 2xl:-bottom-[2rem]  overflow-hidden hidden md:block ${
					direction === "rtl" ? "2xl:-left-80 xl:-left-28 left-2" : " 2xl:-right-80 xl:-right-28 right-2"
				}`}
			/>
			<Tabs handleTab={handleTab} activeTab={tab} />
			{tab === 1 && <TrackOrderForm />}
			{tab === 2 && <QuickBooking />}
			{tab === 3 && <LocationsOurBranches />}
			{tab === 4 && <ShippingPrices />}



		</section>
	);
};

export default TrackYourOrder;
